import { render, staticRenderFns } from "./SolicitarExclusao.vue?vue&type=template&id=2f8ba0f1"
import script from "./SolicitarExclusao.vue?vue&type=script&lang=js"
export * from "./SolicitarExclusao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports